import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import "firebase/compat/firestore";
import React, { useState, useEffect } from "react";
import "firebase/firestore";
import { getFirestore } from "firebase/compat/firestore";

export const ClinicsData = {
  Default: {
    name: "Default clinic",
    logo: process.env.PUBLIC_URL + "/clinicLogo.png",
    enLabel: "Default clinic",
    arLabel: "عيادة Default",
    color: "#004F5B",
    regCollectionName: "defaultRegistrations",
    visitsCollectionName: "defaultVisits",
    homeCareCollectionName: "defaulthomecarevisits",
    prices: {
      Consultation: 0,
      Revisit: 0,
      Sonar: 0,
      ECG: 0,
      Nebulizer: 0,
      Fluids: 0,
      Lab: 0,
      Others: 0,
      Radio: 0,
      Unpaid: 0,
    },
  },
};

const jsonParseFromLocalStorage = (localStorageItem, defaultValue) => {
  try {
    const item = localStorage.getItem(localStorageItem);
    // Check if item exists and is not null
    if (item) {
      return JSON.parse(item);
    } else {
      return defaultValue; // Return default value if item doesn't exist
    }
  } catch (error) {
    console.error("Error parsing JSON from localStorage:", error);
    return defaultValue; // Return default value if JSON parsing fails
  }
};

const firebaseConfig = {
  apiKey: "AIzaSyALsBFKOx-kYOLIO_J6sYQV4fE4Fs-FwSs",
  authDomain: "medical-elhall.firebaseapp.com",
  databaseURL: "https://medical-elhall-default-rtdb.firebaseio.com",
  projectId: "medical-elhall",
  storageBucket: "medical-elhall.appspot.com",
  messagingSenderId: "23715070738",
  appId: "1:23715070738:web:eb7e79df35cbe9dda029cb",
  measurementId: "G-Q7Z49RS867",
};

// firebase.initializeApp(firebaseConfig);

// const selesctedClinicDB = {
//   regs: {
//     Clinic1: ClinicsData["Clinic1"].regCollectionName,
//     Clinic2: "newRegistrations2",
//   },
//   visits: {
//     Clinic1: "newVisits",
//     Clinic2: "newVisits2",
//   },
//   homeVisits: {
//     Clinic1: "homecarevisits",
//     Clinic2: "homecarevisits2",
//   },
// };
// Initialize Firebase
export const myFbApp = firebase.initializeApp(firebaseConfig);
export const func = firebase.functions();
export const firestore = firebase.firestore();

const currentClinic = jsonParseFromLocalStorage(
  "currentClinic",
  ClinicsData["Default"]
);
// export const myFbollection = "newRegistrations";
export const myFbollection = currentClinic
  ? currentClinic.regCollectionName
  : "newRegistrations";
// export const myFbCollecionVisits = "newVisits";
export const myFbCollecionVisits = currentClinic
  ? currentClinic.visitsCollectionName
  : "newVisits";
export const myFbCollectionHomeVisits = currentClinic
  ? currentClinic.homeCareCollectionName
  : "homecarevisits";
export const myMeds = "ptMeds";
export const myFbMrktSrcs = "MrktSrcs";
export const myFbDistricts = "districts";
export const myFbHomecarevisits = "homecarevisits";
export const myFbMedicalFiles = "medicalFiles";
export const myFbMedsDb = "medsDb";
export const myFbNewRegistrations2 = "newRegistrations2";
export const myFbPtPH = "ptPH";
export const myFbOldRegistrations = "values";
export const myFbShobraregistrations = "newRegistrations";
